<template>
    <div class="interview-overview">
        <dl>
            <dt>Summary</dt>
            <dd><EditorText :value="interview.summary" /></dd>

            <dt>Overlap</dt>
            <dd><EditorText :value="interview.overlapRange" /></dd>

            <dt>Relevance</dt>
            <dd><EditorText :value="interview.relevance" /></dd>

            <dt>Source Bias</dt>
            <dd>{{ interview.sourceBias }}</dd>

            <dt>Remuneration</dt>
            <dd>{{ interview.remuneration }}</dd>

            <dt>Key Quotes</dt>
            <dd><EditorText :value="interview.keyQuote1" /></dd>
            <dd><EditorText :value="interview.keyQuote2" /></dd>
            <dd><EditorText :value="interview.keyQuote3" /></dd>
        </dl>
    </div>
</template>

<script>
import EditorText from '@/components/inputs/RichTextEditor/EditorText'
export default {
    name: 'InterviewModalOverviewTab',
    components: { EditorText },
    props: {
        interview: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style>
.interview-overview {
    dl {
        display: grid;
        grid-template-columns: auto minmax(0, 1fr);
    }

    dt {
        grid-column: 1;
        font-weight: 700;
        margin-right: 16px;
    }

    dd {
        grid-column: 2;
    }

    dt,
    dd,
    p {
        font-size: 12pt;
        line-height: 1.4;
    }

    dt,
    dd,
    p:not(:last-child) {
        margin-bottom: 16px;
    }
}
</style>
